module.exports = __webpack_public_path__ + "static/media/tutorial-images-sprite-big.bfe20de8.png";